import axios from "axios";
import Config from "src/config";

const actionGoogleLogout = (clienteId, email) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.api_dev_integrations : Config.api_prod_integrations}/api/google/auth/${clienteId}/logout?email=${email}`
    });
};

export default actionGoogleLogout;
